import React, { useState, useEffect } from 'react'
import { getFirestore, collection, getDocs } from "@firebase/firestore"
import { app } from '../../firebase.js'
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer
} from 'recharts'
import Table from 'react-bootstrap/Table'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'

function DropOffAnalysis() {
  const [chartData, setChartData] = useState([])
  const [tableData, setTableData] = useState([])
  const db = getFirestore(app)

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, "users"))
      const statusCounts = {}

      snapshot.forEach(doc => {
        const data = doc.data()
        const status = data.userStatus || 'inactive'

        statusCounts[status] = (statusCounts[status] || 0) + 1
      })

      // Prepare chart data
      const formattedChartData = Object.keys(statusCounts).map(key => ({
        name: key,
        value: statusCounts[key]
      }))

      // Prepare table data
      const formattedTableData = Object.keys(statusCounts).map(key => ({
        status: key,
        count: statusCounts[key]
      }))

      setChartData(formattedChartData)
      setTableData(formattedTableData)
    }

    fetchData()
  }, [db])

  const COLORS = ['#EF4444', '#F59E0B', '#4F46E5', '#10B981', '#3B82F6']

  return (
    <div className="d-flex">
      <LeftBar />
      <div className="flex-grow-1">
        <Dashnav />
        <div className="clientsComp p-4">
          <h2 className="mb-4">Drop Off Analysis</h2>

          {/* Chart */}
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={150}
                label
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>

          {/* Table */}
          <h3 className="mt-5 mb-3">Status Summary</h3>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Status</th>
                <th>Number of Students</th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr key={index}>
                  <td>{row.status}</td>
                  <td>{row.count}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default DropOffAnalysis